var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "yxtbiz-attachment-check hover-bg-primary-1",
      class:
        _vm.mode === "thumbnail"
          ? "yxtbiz-attachment-thumbnailMode"
          : "yxtbiz-attachment-textMode",
    },
    [
      _vm.mode === "thumbnail"
        ? _c(
            "div",
            {
              staticClass: "yxtbiz-attachment-check__thumbnail",
              class: _vm.data.viewUrl
                ? ""
                : "yxtbiz-attachment-check__" + _vm.fileThumbnail,
              style: {
                backgroundImage:
                  _vm.data.fileType === "picture"
                    ? "url(" + _vm.data.url + ")"
                    : _vm.data.viewUrl
                    ? "url(" + _vm.data.viewUrl + ")"
                    : null,
              },
            },
            [
              _vm.mode === "thumbnail" && _vm.needDelete
                ? _c(
                    "span",
                    {
                      staticClass: "yxtbiz-attachment-check__delete",
                      on: { click: _vm.handleClose },
                    },
                    [_c("i", { staticClass: "yxt-icon-close" })]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _c("div", { staticClass: "yxtbiz-attachment-check__text" }, [
        _c(
          "span",
          {
            staticClass: "yxtbiz-attachment-check__name hover-primary-6",
            class: _vm.needDetail ? "hand" : "",
            on: { click: _vm.viewDetail },
          },
          [
            _vm.mode === "text"
              ? _c("yxt-svg", {
                  staticClass: "yxtbiz-attachment-check__icon v-mid",
                  attrs: {
                    "icon-class": "attachment",
                    width: "14px",
                    height: "14px",
                    "remote-url": _vm.mediaPath,
                  },
                })
              : _vm._e(),
            _c(
              "yxt-tooltip",
              {
                staticClass: "yxtbiz-attachment-check__val",
                attrs: {
                  content: _vm.data.name,
                  placement: "top",
                  "open-filter": "",
                },
              },
              [_c("span", [_vm._v(_vm._s(_vm.data.name))])]
            ),
          ],
          1
        ),
        _vm.needDownload
          ? _c("i", {
              staticClass:
                "yxt-icon-download yxtbiz-attachment-check__download hover-primary-6 color-gray-6",
              on: { click: _vm.handleDownload },
            })
          : _vm._e(),
        _vm.mode === "text" && _vm.needDelete
          ? _c("i", {
              staticClass: "yxt-icon-close hover-primary-6 color-gray-6",
              on: { click: _vm.handleClose },
            })
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }